import Vue from 'vue';
import { Backend } from '@/_axios';

// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';

export const LOAD_USER_RATES = 'LOAD_USER_RATES';
export const SET_USER_RATES = 'SET_USER_RATES';

export const NEW_USER_RATE = 'NEW_USER_RATE';
export const CREATE_USER_RATE = 'CREATE_USER_RATE';
export const CREATE_USER_RATE_ERROR = 'CREATE_USER_RATE_ERROR';

const state = {
  sortedRates: {},
  userRateNotification: {
    status: 'loading',
    message: '',
    data: {}
  }
};

const getters = {
  ratesByUser: (state) => {
    return state.sortedRates;
  },
  ratesOnDate: (state) => (date, userId) => {
    const sortedRates = state.sortedRates;
    const d = new Date(date);
    userId = parseInt(userId);
    if (!sortedRates[userId]) return 0;

    let rate = 0;
    for (let i = 0; i < sortedRates[userId].length; i++) {
      if (d < new Date(sortedRates[userId][i].starts_at)) {
        break;
      } else {
        rate = sortedRates[userId][i].internal_rate;
      }
    }
    return rate / 100;
  },
  userRateNotification: (state) => {
    return state.userRateNotification;
  }
};

const actions = {
  [LOAD_USER_RATES]: function ({ commit }) {
    Backend.get('/api/jira-user-rates', { noForbidden: true }).then((response) => {
      commit('SET_USER_RATES', { data: response.data });
    }).catch(() => {
      console.log('Unable to get user rates');
    });
  },
  [NEW_USER_RATE]: function ({ commit }, { userId, startsAt, internalRate }) {
    Backend.post('/api/jira-new-user-rate', { userId: userId, startsAt: startsAt, internalRate: internalRate }).then((response) => {
      commit('CREATE_USER_RATE', { data: response.data.data.data, message: response.data.data.message });
    }, (err) => {
      console.log(err.response);
      commit('CREATE_USER_RATE_ERROR', err.response.data.messages);
    });
  }
};

const mutations = {
  [SET_USER_RATES]: function (state, { data }) {
    const userRates = {};

    data.forEach((rate) => {
      if (!userRates[rate.user_id]) {
        userRates[rate.user_id] = [];
      }
      userRates[rate.user_id].push(rate);
    });

    for (const userId in userRates) {
      userRates[userId].sort((a, b) => {
        return new Date(a.startsAt) - new Date(b.startsAt);
      });
    }
    state.sortedRates = userRates;
  },
  [CREATE_USER_RATE]: function (state, { data, message }) {
    if (!state.sortedRates[data.user_id]) Vue.set(state.sortedRates, data.user_id, []);
    state.sortedRates[data.user_id].push(data);
    state.userRateNotification = {
      status: 'success',
      message: message,
      data: data
    };
  },
  [CREATE_USER_RATE_ERROR]: function (state, messages) {
    state.userRateNotification = {
      status: 'error',
      message: messages,
      data: {}
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
